import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        popup: {
          ...store.getState().i18n.translations.en.common.popup,
          followAlert: {
            TITLE: 'Follow Alerts',
            HERE: 'here',
            CLICK_HERE: 'click here',
            CLICK_HERE_FIRST_UPPERCASE: 'Click here',
            FOLLOWING_LIST: 'Following List',
            ALERT_FOR_COMPANY_TITLE:
              "Alerts for the Company's basic information",
            ALERT_FOR_COMPANY_NOTE_1:
              "Receive or decline updates on the company's basic information. This action will add/remove the company from the portfolio %{link}.",
            ALERT_FOR_COMPANY_NOTE_2:
              "View this portfolio's profile settings %{link}.",
            ALERT_FROM_PORTFOLIO_TITLE: "Alerts from the Company's portfolios",
            ALERT_FROM_PORTFOLIO_NOTE_1:
              'This company can receive alerts from portfolios below. To receive or decline alerts triggered from these portfolios, toggle on/off.',
            ALERT_FROM_PORTFOLIO_NOTE_2:
              'To add or remove this company from any portfolios, %{link}.',
            ALERT_FROM_PORTFOLIO_NOTE_3:
              'To change the alert profile for these portfolios, %{link}.',
            PORTFOLIO_LIST: 'Portfolio List',
            PORTFOLIO_NAME: 'Portfolio Name',
            PROFILE_NAME: 'Profile Name',
            NO_PORTFOLIOS:
              'This company is not in any portfolios with an alert profile.<br/>%{link} to modified portfolios that contain this company.',
            CONFIRM_CANCEL: 'Are you sure you want to discard all changes?',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        popup: {
          ...store.getState().i18n.translations.vi.common.popup,
          followAlert: {
            TITLE: 'Theo Dõi Cảnh Báo',
            HERE: 'tại đây',
            CLICK_HERE: 'vào đây',
            CLICK_HERE_FIRST_UPPERCASE: 'vào đây',
            FOLLOWING_LIST: 'Danh sách theo dõi',
            ALERT_FOR_COMPANY_TITLE: 'Cảnh báo Thông tin cơ bản của công ty',
            ALERT_FOR_COMPANY_NOTE_1:
              'Nhận hoặc từ chối cập nhật thông tin cơ bản của công ty. Hành động này sẽ thêm/xóa công ty khỏi danh mục %{link}.',
            ALERT_FOR_COMPANY_NOTE_2:
              'Xem cài đặt hồ sơ của danh mục này %{link}.',
            ALERT_FROM_PORTFOLIO_TITLE:
              'Cảnh báo từ các danh mục có chứa công ty',
            ALERT_FROM_PORTFOLIO_NOTE_1:
              'Công ty này có thể nhận được cảnh báo từ các danh mục bên dưới. Bật/tắt để nhận hoặc từ chối nhận cảnh báo được kích hoạt từ các danh mục này.',
            ALERT_FROM_PORTFOLIO_NOTE_2:
              'Nhấp %{link} để thêm hoặc xóa công ty này khỏi danh mục bất kì.',
            ALERT_FROM_PORTFOLIO_NOTE_3:
              'Nhấp %{link} để thay đổi cài đặt cảnh báo cho các danh mục này.',
            PORTFOLIO_LIST: 'Danh Sách Danh Mục',
            PORTFOLIO_NAME: 'Tên Danh Mục',
            PROFILE_NAME: 'Tên Bộ Quy Tắc',
            NO_PORTFOLIOS:
              'Công ty này không có trong bất kỳ danh mục nào có cài đặt cảnh báo.<br/>Nhấn %{link} để điều chỉnh các danh mục có chứa công ty này.',
            CONFIRM_CANCEL:
              'Bạn có chắc chắn muốn hủy các thay đổi đã được thực hiện?',
          },
        },
      },
    },
  }),
)
